/**
 * Copyright 2018 Ambrosus Inc.
 * Email: tech@ambrosus.com
 */
import React from 'react';
import './App.scss';

import Header from './components/Header';
import Footer from './components/Footer/Footer';
import Routes from './Routes';
const App = () => {
  return (
    <div className='App'>
      <Header />
      <main className='Main'>
        <Routes />
      </main>
      <Footer />
    </div>
  );
};

export default App;
